"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNoAncestorBindingConstraintsWithName = isNoAncestorBindingConstraintsWithName;
const isBindingConstraintsWithName_1 = require("./isBindingConstraintsWithName");
const isNoAncestorBindingConstraints_1 = require("./isNoAncestorBindingConstraints");
function isNoAncestorBindingConstraintsWithName(name) {
    return (0, isNoAncestorBindingConstraints_1.isNoAncestorBindingConstraints)((0, isBindingConstraintsWithName_1.isBindingConstraintsWithName)(name));
}
//# sourceMappingURL=isNoAncestorBindingConstraintsWithName.js.map